"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugError = void 0;
/**
 * If the app is in debug mode, prints an error to the console. In production builds, this function does nothing.
 *
 * @param args
 */
const debugError = (...args) => {
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error(...args);
    }
};
exports.debugError = debugError;
